import { explicitMaybe } from '@execonline-inc/decoders';
import { identity } from '@kofno/piper';
import { Decoder, dateISO, field, number, oneOf, string, succeed } from 'jsonous';
import { readonlyArray } from '../../../../../Decoders';
import { resourceDecoder } from '../../../../../Resource/Decoders';
import { formTemplatesDecoder } from '../../../../../Resource/FormTemplates/Decoders';
import {
  License,
  LicenseAllocationsFormPayload,
  LicenseAllocationsFormResource,
  LicenseResource,
  SubmissionResponse,
  SubmissionSuccess,
  SubmittedLicenseAllocationsPayload,
  SubmittedLicenseAllocationsResource,
  ValidationErrors,
} from './Types';

export const licenseDecoder: Decoder<License> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('expiresOn', field('expires_on', dateISO))
  .assign('activationsRemaining', field('activations_remaining', explicitMaybe(number)));

export const licenseResourceDecoder: Decoder<LicenseResource> = resourceDecoder(licenseDecoder);

export const licenseAllocationsFormPayloadDecoder: Decoder<LicenseAllocationsFormPayload> = succeed(
  {},
).assign(
  'allocatableLicenses',
  field('allocatable_licenses', readonlyArray(licenseResourceDecoder)),
);

export const licenseAllocationsFormResourceDecoder: Decoder<LicenseAllocationsFormResource> =
  resourceDecoder(licenseAllocationsFormPayloadDecoder).assign('templates', ({ links }) =>
    field('templates', formTemplatesDecoder(links)),
  );

export const submittedLicenseAllocationsPayloadDecoder: Decoder<SubmittedLicenseAllocationsPayload> =
  succeed({}).assign(
    'allocatedLicenses',
    field('allocated_licenses', readonlyArray(licenseResourceDecoder)),
  );

export const submittedLicenseAllocationsResourceDecoder: Decoder<SubmittedLicenseAllocationsResource> =
  resourceDecoder(submittedLicenseAllocationsPayloadDecoder);

export const submissionSuccessDecoder: Decoder<SubmissionSuccess> =
  submittedLicenseAllocationsResourceDecoder.map((resource) => ({
    kind: 'submission-success',
    resource,
  }));

export const validationErrorsDecoder: Decoder<ValidationErrors> =
  licenseAllocationsFormResourceDecoder.map((resource) => ({
    kind: 'validation-errors',
    resource,
  }));

export const submissionResponseDecoder: Decoder<SubmissionResponse> = oneOf<SubmissionResponse>([
  submissionSuccessDecoder.map<SubmissionResponse>(identity),
  validationErrorsDecoder.map<SubmissionResponse>(identity),
]);
